import { ActionService } from 'dashboard-services/services';

export default (() => {
  const USER_DETAILS_VIEWS = {
    ROLES: "ROLES",
    SETTINGS: "SETTINGS",
    DEACTIVATION: "DEACTIVATION",
    DEACTIVATION_RUNNING: "DEACTIVATION_RUNNING",
    DELETION: "DELETION",
    DELETION_RUNNING: "DELETION_RUNNING"
  }

  const formatToFirstUpperCase = string => String(string).toLowerCase().capitaliseFirstLetter()

  const ON_CHANGE = "ON_CHANGE_SELECTED_BASIC_USER_DETAILS"
  const onChange = ActionService.makeActionCreator(ON_CHANGE, "value", "name")

  const ON_CURRENT_VIEW_CHANGE = "ON_CURRENT_VIEW_CHANGE_BASIC_USER_DETAILS"
  const onCurrentViewChange = ActionService.makeActionCreator(ON_CURRENT_VIEW_CHANGE, "value")

  const CLEAN_ALL = "CLEAN_ALL_SELECTED_BASIC_USER_DETAILS"
  const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)

  return {
    USER_DETAILS_VIEWS,
    formatToFirstUpperCase,
    ON_CHANGE,
    onChange,
    ON_CURRENT_VIEW_CHANGE,
    onCurrentViewChange,
    CLEAN_ALL,
    cleanAll
  }
})()